import { LogoModal, createOrganizationLogoConfig } from "@/components/logo-modal";

interface AddLogoModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  organisationId: number;
  organisationName: string;
  currentLogoUrl?: string | null;
}

export function AddLogoModal({
  isOpen,
  onOpenChange,
  organisationId,
  organisationName,
  currentLogoUrl,
}: AddLogoModalProps) {
  const config = createOrganizationLogoConfig(organisationId, organisationName);
  
  return (
    <LogoModal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      config={config}
      currentLogoUrl={currentLogoUrl}
    />
  );
}